import React, { useEffect } from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, message, type = 'confirm', onConfirm, onCancel, onClose, autoDismiss = false, duration = 3000 }) => {
  useEffect(() => {
    if (isOpen && autoDismiss) {
      const timer = setTimeout(() => {
        if (onClose) {
          onClose();
        } else if (onCancel) {
          onCancel();
        }
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoDismiss, duration, onClose, onCancel]);

  // Dla kompatybilności z obecnym kodem - obsługuj brak parametru isOpen
  // Traktuj jako włączony, jeśli mamy message i onConfirm lub onCancel
  const shouldShow = isOpen !== undefined ? isOpen : (message && (onConfirm || onCancel));

  if (!shouldShow) return null;

  const handleButtonClick = (action) => {
    if (action === 'confirm' && onConfirm) {
      onConfirm();
    } else if (action === 'cancel' && onCancel) {
      onCancel();
    } else if (onClose) {
      onClose();
    }
  };

  const renderButtons = () => {
    if (type === 'confirm') {
      return (
        <div className="modal-actions">
          <button className="modal-button confirm" onClick={() => handleButtonClick('confirm')}>Potwierdź</button>
          <button className="modal-button cancel" onClick={() => handleButtonClick('cancel')}>Anuluj</button>
        </div>
      );
    } else {
      // For info, success, error types, show a single 'OK' or 'Zamknij' button
      return (
        <div className="modal-actions">
          <button className="modal-button ok" onClick={() => handleButtonClick('ok')}>OK</button>
        </div>
      );
    }
  };

  const backdropClass = type === 'confirm' ? 'modal-backdrop' : 'modal-backdrop notification';

  return (
    <div className={backdropClass}>
      <div className={`modal-content ${type}`}>
        <p>{message}</p>
        {/* Only show buttons if it's a confirm type or not auto-dismissing (e.g., persistent error messages) */}
        {type === 'confirm' ? renderButtons() : (!autoDismiss && renderButtons())}
      </div>
    </div>
  );
};

export default ConfirmationModal; 